"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Why is crawl-space encapsulation important for homeowners in Iowa?",
  answer: "Iowa’s high humidity and freezing winters can cause moisture buildup in unprotected crawl spaces, leading to mold, wood rot, and poor indoor air quality. Connecting with a qualified professional helps create a controlled environment that protects your home’s structure year-round."
}, {
  question: "How much does a typical crawl-space encapsulation referral cost in Des Moines?",
  answer: "Every home is unique, so costs vary based on the square footage and specific issues present. We connect you with local experts who provide free, comprehensive inspections to give you an exact, no-surprise quote tailored to your home's specific needs without any upfront referral fees."
}, {
  question: "What kind of warranty can homeowners expect from recommended professionals?",
  answer: "Most reputable crawl-space contractors offer robust, long-term warranties on their encapsulation systems and vapor barriers. The professionals we recommend are selected based on their commitment to quality workmanship and the strength of the guarantees they provide."
}, {
  question: "Will a professional encapsulation help lower my energy bills?",
  answer: "Yes. When a professional seals the crawl space and installs proper insulation, it prevents unconditioned outside air from entering your home. This allows your HVAC system to work more efficiently, often resulting in noticeably lower energy costs."
}, {
  question: "How long does the installation process usually take for a professional?",
  answer: "Most professional crawl-space encapsulation projects in the Des Moines area are completed within 1 to 3 days. The exact timeline depends on the size of your crawl space and the specific scope of work defined by the contractor."
}];
export default function CommonQuestions() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: accordionRef,
    isVisible: isAccordionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="common-questions" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div ref={headerRef} className={`text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tight mb-4">
            Common Questions About Finding a Trusted Crawl-Space Professional
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Everything you need to know about finding a trusted local crawl-space professional for your home.
          </p>
        </div>

        <div ref={accordionRef} className={`transition-all duration-700 delay-200 ease-out ${isAccordionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border rounded-lg px-6 bg-card data-[state=open]:bg-muted/40 transition-colors duration-300 shadow-sm">
                <AccordionTrigger className="text-left text-base md:text-lg font-semibold text-foreground hover:no-underline py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-16 text-center flex flex-col items-center justify-center space-y-4">
          <p className="text-foreground font-medium">
            Still have questions about finding the right crawl-space professional?
          </p>
          <Button asChild size="lg" className="rounded-lg px-8">
            <Link to="/ContactPage">Request Free Inspection</Link>
          </Button>
        </div>
      </div>
    </section>;
}